// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import http from 'axios'
import reveal from './directives/reveal'

// 全站滚动入场指令（共享单个 IntersectionObserver，详见 directives/reveal.js）
Vue.directive('reveal', reveal)

// The public site does not use Element UI or Video.js. Keeping those global
// imports made them part of the initial bundle, so Axios is exposed directly
// for the few legacy utility modules that may still need it.
Vue.prototype.$http = http
Vue.config.productionTip = false
http.defaults.baseURL = '/api'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js